import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import { listInformeGestionSitioWeb } from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import './DocumentoInformeGestion.css';

const DocumentoInformeGestion = () => {
  const [informes, setInformes] = useState(null);

  useEffect(() => {
    listInformeGestionSitioWeb()
      .then((response) => {
        setInformes(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Informe de Gestión"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <h7 className="informe-gestion-title">
          Puede descargar los informes de gestión en los siguientes enlaces.
        </h7>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            {informes !== null &&
              informes.length > 0 &&
              informes.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <a rel="noreferrer" target="_blank" href={item.link}>
                      {item.nombre}
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default React.memo(DocumentoInformeGestion);
